import knownWidgets from './known_widgets'

const miscUtils = {
    isMobile () {
        return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
    },
    isValidHex (string) {
        return /^#[0-9A-F]{6}$/i.test(string)
    },
    buildIframeUrl ({ widgetType, clinicWidgetId, envVariables, widgetConfigs = {} }) {
        /**
         *
         */
        const iframeBaseUrl = envVariables.VUE_APP_BASE_WIDGET_URL_FOR_IFRAME

        if (!knownWidgets.includes(widgetType)) {
            console.log(`WARNING:Uknown widget type:${widgetType}. Using default.`)
        }

        let widgetTypeEndpoint = envVariables.VUE_APP_BASE_FUNNEL_WIDGET_URL_FOR_IFRAME
        if (widgetType === 'anamnesis_widget') {
          widgetTypeEndpoint = envVariables.VUE_APP_BASE_ANAMNESIS_WIDGET_URL_FOR_IFRAME
        } else if (widgetType === 'emergency_widget') {
            // handle
        }

        let iframeUrl = `${iframeBaseUrl}${widgetTypeEndpoint}`
        const params = this._buildQueryParams({
            providerId: clinicWidgetId,
            assessmentId: widgetConfigs.assessmentId,
            contentColor: widgetConfigs.contentColor,
            leftAligned: widgetConfigs.leftAligned,
            encodedTrafficSource: widgetConfigs.encodedTrafficSource,
        })
        if (params) { iframeUrl = iframeUrl + '?' + params }
        return iframeUrl
    },

    _buildQueryParams ({
        providerId,
        assessmentId = null,
        contentColor = null,
        leftAligned = null,
        encodedTrafficSource = null,
    }) {
        const _queryParams = []
        if (providerId) {
            _queryParams.push(`provider=${providerId}`)
        }
        if (assessmentId) {
            _queryParams.push(`resume=${assessmentId}`)
        }
        if (contentColor) {
            // Note: Strip the # and assume it is added by receiver.
            _queryParams.push(`color=${contentColor.replace('#', '')}`)
        }
        if (leftAligned) {
            _queryParams.push(`left=${leftAligned}`)
        }
        if (encodedTrafficSource) {
            _queryParams.push(`source=${encodedTrafficSource}`)
        }
        return _queryParams.join('&')
    },
}

export default miscUtils
